import { loginApi, logoutApi } from '@/api/auth/login'
import { getCookie, removeCookie, saveCookie } from '@/utils/cookie'

const state = {
  token: getCookie('access_token') || '',
  profile: getCookie('profile') ? JSON.parse(getCookie('profile')) : {}
}

const getters = {
  token: state => state.token,
  profile: state => state.profile
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_PROFILE: (state, profile) => {
    state.profile = profile
  },
  RESET_TOKEN: (state) => {
    state.token = ''
    removeCookie('access_token')
    state.profile = {}
    removeCookie('profile')
  }
}

const actions = {
  async loginAction ({
    commit
  }, params) {
    try {
      const response = await loginApi(params)
      if (response.status === 200) {
        // eslint-disable-next-line camelcase
        let access_token = response.data.data.access_token
        commit('SET_TOKEN', access_token)
        saveCookie('access_token', access_token)
        let profile = response.data.data.profile
        commit('SET_PROFILE', profile)
        saveCookie('profile', profile)
      }
      return response
    } catch (error) {
      return error
    }
  },
  async logoutAction ({
    commit
  }) {
    try {
      const response = await logoutApi()
      if (response.status === 200) {
        commit('RESET_TOKEN')
      }
      return response
    } catch (error) {
      return error
    }
  },
  resetTokenAction ({
    commit
  }) {
    return new Promise(resolve => {
      commit('RESET_TOKEN')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js